/**
 * Report every successful API write to the admin row-counter signal
 * (utils/admin-counts.ts). Admin pages write through three paths — the typed
 * `client`, `authedFetch` and plain `fetch` with a Bearer header (locales,
 * icons, templates, chat…) — so the cheapest complete hook is `window.fetch`
 * itself. The typed client keeps its own middleware too, in case it captured
 * the unpatched fetch before this plugin ran; bumps are debounced, so double
 * reports cost nothing.
 */
import { noteRequest } from '~/utils/admin-counts'

export default defineNuxtPlugin(() => {
  const w = window as Window & { __qcmsAdminCountsPatched?: boolean }
  if (w.__qcmsAdminCountsPatched) return
  w.__qcmsAdminCountsPatched = true
  const original = window.fetch.bind(window)
  window.fetch = async (input: RequestInfo | URL, init?: RequestInit) => {
    const res = await original(input, init)
    try {
      const url = typeof input === 'string' ? input : input instanceof URL ? input.href : input.url
      const method = init?.method || (input instanceof Request ? input.method : 'GET')
      noteRequest(method, url, res.ok)
    } catch {
      /* never break a request over a counter */
    }
    return res
  }
})
